<template>
  <div id="home">
    <div v-if="getUserMail != null && typeof getUserMail() != 'undefined'">
      <h1 class="text-center" v-if="autoren.autoren && getUserMail()">{{'Hallo ' + autoren.autoren.find(x => x.mail == getUserMail()).vorname + ', eine Freude 👍'}}</h1>
      <v-divider></v-divider>
      <v-list>
         <v-list-item>
          <v-switch v-model="dad" label="Drag & Drop"></v-switch>
        </v-list-item>
        <v-list-item>
          <v-switch v-model="delmo" label="Löschmodus"></v-switch>
        </v-list-item>
        <draggable v-model="sitemap.sitemap" @end="end()" :disabled="!dad">
          <v-list-group :value="false" v-for="Fach in sitemap.sitemap" :key="Fach.title">
            <template v-slot:activator>
              <v-list-item class="pa-0">
                <v-list-item-title class="body-2">{{Fach.title}}</v-list-item-title>
                <v-list-item-action>
                  <v-btn @click="item=Fach.title; zustand = 'Fach'; dialog2 = true" icon text>
                    <v-icon color="#f39c12">{{mdiedit}}</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action v-if="delmo">
                  <v-btn @click="item=Fach.title; dialog = true; zustand = 'Fach'" icon text>
                    <v-icon color="#e74c3c">{{mdidelete}}</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
            <draggable v-model="Fach.themen" @end="end()" :disabled="!dad">
              <v-list-group no-action sub-group :value="false" v-for="Thema in Fach.themen" :key="Thema.title">
                <template v-slot:activator>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="body-2">{{Thema.title}}</v-list-item-title>
                    <v-list-item-action @click="item=Thema.title; Auswahl.Fach = Fach.title; zustand = 'Thema'; dialog2 = true">
                      <v-icon color="#f39c12">{{mdiedit}}</v-icon>
                    </v-list-item-action>
                    <v-list-item-action v-if="delmo" @click="item=Thema.title; Auswahl.Fach = Fach.title; zustand = 'Thema'; dialog = true">
                      <v-icon color="#e74c3c">{{mdidelete}}</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
                <draggable v-model="Thema.lernzettel" @end="end()" :disabled="!dad">
                  <v-list-item class="ml-8" v-for="Lernzettel in Thema.lernzettel" :key="Lernzettel.link">
                    <router-link :to="Lernzettel.link">{{Lernzettel.title}}</router-link>
                    <v-list-item-content class="body-2"></v-list-item-content>
                    <v-list-item-action @click="item=Lernzettel.link; Auswahl.Fach = Fach.title; Auswahl.Thema = Thema.title; zustand = 'Lernzettel'; dialog2 = true">
                      <v-icon color="#f39c12">{{mdiedit}}</v-icon>
                    </v-list-item-action>
                    <v-list-item-action v-if="delmo" @click="item=Lernzettel.link; Auswahl.Fach = Fach.title; Auswahl.Thema = Thema.title; zustand = 'Lernzettel';dialog = true">
                      <v-icon color="#e74c3c">{{mdidelete}}</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </draggable>
                <v-text-field class="ml-12 pl-6 mr-8" color="#2ecc71" v-model="Titel" :append-icon="plus" label="Lernzettel hinzufügen" single-line @click:append="Auswahl.fach = Fach.title; Auswahl.thema = Thema.title; addLernzettel()"></v-text-field>
              </v-list-group>
            </draggable>
            <v-text-field class="ml-10 mr-10" color="#2ecc71" v-model="Thema" :append-icon="plus" label="Thema hinzufügen" single-line @click:append="addThema(Fach.title)"></v-text-field>
          </v-list-group>
        </draggable>
        <v-text-field class="ml-3 mr-3" color="#2ecc71" v-model="Fach" :append-icon="plus" label="Fach hinzufügen" single-line @click:append="addFach()"></v-text-field>
      </v-list>
      <v-divider></v-divider>
      <v-list v-if="ungelistet">
        <v-list-group no-action :value="false">
          <template v-slot:activator>
            <v-list-item class="pa-0">
              <v-list-item-title class="body-2">Ungelistet</v-list-item-title>
            </v-list-item>
          </template>
            <v-list-item class="pl-6" v-for="Lernzettel in ungelistet.ungelistet" :key="Lernzettel.link">
              <router-link :to="Lernzettel.link">{{Lernzettel.title}}</router-link>
              <v-list-item-content class="body-2"></v-list-item-content>
              <v-list-item-action @click="unsel = Lernzettel.link; editUngelistet()">
                <v-icon color="#f39c12">{{mdiedit}}</v-icon>
              </v-list-item-action>
              <v-list-item-action v-if="delmo" @click="unsel = Lernzettel.link; deleteUngelistet()">
                <v-icon color="#e74c3c">{{mdidelete}}</v-icon>
              </v-list-item-action>
            </v-list-item>
          <v-text-field class="ml-3 pl-3 mr-3" color="#2ecc71" v-model="unt" :append-icon="plus" label="Lernzettel hinzufügen" single-line @click:append="addUngelistet()"></v-text-field>
      </v-list-group>
      </v-list>
      <v-divider></v-divider>
    </div>
    <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <p class="pa-5">{{'Wollen Sie ' + item + ' löschen?'}}</p>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialog = false">Schließen</v-btn>
            <v-btn color="red darken-1" text @click="dialog = false; del()">Löschen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog2" max-width="350">
        <v-card>
          <p class="pa-5">{{'Wollen Sie ' + item + ' umbenennen?'}}</p>
          <v-text-field class="ma-6" label="Neuer Titel" single-line v-model="changed"></v-text-field>
          <v-card-actions>
            <v-btn class="ml-3" color="green darken-1" text @click="dialog2 = false; edit()">Speichern</v-btn>
            <v-btn color="red darken-1" text @click="dialog2 = false">Abbrechen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-snackbar v-model="snackbar">Bereits belegt.
        <v-btn color="red" text @click="snackbar = false">Schließen</v-btn>
    </v-snackbar>
  </div>
</template>

<style scoped>
a {
  text-decoration: none; /* no underline */
}
.blackx{
  color: black;
}
.title{
    padding-bottom: 0px;
}
.text{
    padding-top: 0px;
}
.tit{
    margin: 0px 0px 0px;
}
</style>

<script>
  import draggable from 'vuedraggable'
  import { db } from '../db'
  import { fb } from '../db'
  import { mdiPlus} from '@mdi/js'
  import { mdiDelete} from '@mdi/js'
  import { mdiFileEdit } from '@mdi/js'
  const blog = db.collection('lernzettel');
  const b2 = db.collection('shared');
  const extra = db.collection('lernzettel-extra');
  const ed = db.collection('lernzettel-editor');

  const algoliasearch = require('algoliasearch');
  const client = algoliasearch('ZC0BNQ3DEW', '8f886ac8f2f380019993cfceaa3b9f51');
  const index = client.initIndex('lernzettel');

  export default {
    name: 'home',
    components: {
      draggable
    },
    firestore: {
      sitemap: extra.doc('sitemap'),
      autoren: b2.doc('autoren'),
      ungelistet: extra.doc('ungelistet')
    },
    data: () => ({
      sitemap: [],
      links: [],
      autoren: {},
      kategorien: {},
      unsel: "",
      dad: false,
      plus: mdiPlus,
      ungelistet: [],
      dialog: false,
      dialog2: false,
      delmo: false,
      title: "",
      slug: "",
      unt: "",
      snackbar: false,
      mdidelete: mdiDelete,
      mdiedit: mdiFileEdit,
      selected: {},
      zustand: '',
      changed: '',
      Fach: '',
      item: '',
      Thema: '',
      Titel: '',
      Slug: '',
      Auswahl: {},
      Fächer: {}
    }),
    methods: {
    addThema: function(facht){
      this.sitemap.sitemap.find(x => x.title === facht).themen.push({title: this.Thema, lernzettel: []});
      extra.doc('sitemap').set({ sitemap: this.sitemap.sitemap });
      extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + facht + ' erstellt.'}, {merge: true})
      this.Thema = '';
    },
    addFach: function() {
      if(this.sitemap == null) {
        this.sitemap = []
        this.sitemap.sitemap = []
      }
      if(typeof this.sitemap.sitemap.find(x => x.title === this.Fach) == 'undefined'){
        this.sitemap.sitemap.push({title: this.Fach, themen: []});
        extra.doc('sitemap').set({ sitemap: this.sitemap.sitemap });
        extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.Fach + ' erstellt.'}, {merge: true})
      } else {
        this.snackbar = true;
      }
      this.Fach = '';
    },
    addLernzettel: function(){
      this.Slug = this.toSlug(this.Titel);
      if(typeof this.sitemap.sitemap.reduce((arr, elem) => arr.concat(elem.themen), []).reduce((arr, elem) => arr.concat(elem.lernzettel), []).find(x => x.link === this.Slug) == 'undefined') {
        this.sitemap.sitemap.find(x => x.title === this.Auswahl.fach).themen.find(x => x.title === this.Auswahl.thema).lernzettel.push({title: this.Titel, link: this.Slug});
        var titel = this.Titel;
        extra.doc('sitemap').set({ sitemap: this.sitemap.sitemap });
        ed.doc(this.Slug).set({content: ""})
        blog.doc(this.Slug).set({slug: this.Slug, title: this.Titel, autoren: [fb.auth().currentUser.email], einordnung: {fach: {title: this.Auswahl.fach, slug: this.toSlug(this.Auswahl.fach)}, thema: {title: this.Auswahl.thema, slug: this.toSlug(this.Auswahl.thema)}}}).then(() => this.$router.push({path: this.Slug}))
        extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.Slug + ' erstellt.'}, {merge: true})
        this.Titel = '';
      } else {
        this.snackbar = true;
        this.Titel = '';
      }
    },
    editFach: function() {
      if(typeof this.sitemap.sitemap.find(x => x.title === this.changed) == 'undefined'){
      this.sitemap.sitemap.find(x => x.title === this.item).title = this.changed;
      extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.item + ' zu' + this.changed + ' umbanannt.'}, {merge: true})
      extra.doc('sitemap').set({ sitemap: this.sitemap.sitemap });
      } else {
        this.snackbar = true;
      }
    },
    editThema: function() {
      this.sitemap.sitemap.find(x => x.title === this.Auswahl.Fach).themen.find(x => x.title === this.item).title = this.changed;
      extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.item + ' zu' + this.changed + ' umbanannt.'}, {merge: true})
      extra.doc('sitemap').set({ sitemap: this.sitemap.sitemap });
    },
    editLernzettel: function() {
      if(typeof this.sitemap.sitemap.reduce((arr, elem) => arr.concat(elem.themen), []).reduce((arr, elem) => arr.concat(elem.lernzettel), []).find(x => x.link === this.toSlug(this.changed)) == 'undefined') {
      this.sitemap.sitemap.find(x => x.title === this.Auswahl.Fach).themen.find(x => x.title === this.Auswahl.Thema).lernzettel.find(x => x.title === this.item).title = this.changed;
      extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.item + ' zu' + this.changed + ' umbanannt.'}, {merge: true})
      extra.doc('sitemap').set({ sitemap: this.sitemap.sitemap });
      } else {
        this.snackbar = true;
      }
    },
    edit: function() {
      if(this.zustand == 'Fach'){
        this.editFach();
      } else if (this.zustand == 'Thema') {
        this.editThema();
      } else {
        this.editLernzettel();
      }
    },
    del: function() {
      if(this.zustand == 'Fach'){
        this.deleteFach();
      } else if (this.zustand == 'Thema') {
        this.deleteThema(this.Auswahl.Fach, this.item);
      } else {
        this.deleteLernzettel(this.Auswahl.Fach, this.Auswahl.Thema, this.item);
      }
      extra.doc('sitemap').set({ sitemap: this.sitemap.sitemap });
    },
    deleteFach: function() {
      this.sitemap.sitemap.find(x => x.title === this.item).themen.forEach(element => {
        this.deleteThema(this.item, element.title)
      });
      extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.item + ' gelöscht.'}, {merge: true})
      this.sitemap.sitemap = this.sitemap.sitemap.filter(x => x.title !== this.item)
    },
    deleteThema: function(fach, thema) {
      this.sitemap.sitemap.find(x => x.title === fach).themen.find(x => x.title === thema).lernzettel.forEach(element => {
        this.deleteLernzettel(fach, thema, element.link)
      });
      extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + thema + ' gelöscht.'}, {merge: true})
      this.sitemap.sitemap.find(x => x.title === fach).themen = this.sitemap.sitemap.find(x => x.title === fach).themen.filter(x => x.title !== thema)
    },
    deleteLernzettel: function(Fach, Thema, Lernzettel) {
      blog.doc(this.toSlug(Lernzettel)).get().then(doc => {
        if (doc.exists) {
          db.collection('lernzettel-deleted').doc(this.toSlug(Lernzettel)).set(doc.data()).then(() => this.$router.push({path: '/'}))
          blog.doc(this.toSlug(Lernzettel)).delete();
        }
      })
      index.deleteObject(this.toSlug(Lernzettel)).then(({ objectID }) => {
        //
      });
      extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + Lernzettel + ' gelöscht.'}, {merge: true})
      this.sitemap.sitemap.find(x => x.title === Fach).themen.find(x => x.title === Thema).lernzettel = this.sitemap.sitemap.find(x => x.title === Fach).themen.find(x => x.title === Thema).lernzettel.filter(lernzettel => lernzettel.link!==Lernzettel);
    },
    addUngelistet: function(){
      this.Slug = this.toSlug(this.unt);
      if(typeof this.ungelistet.ungelistet.find(x => x.link === this.Slug) == 'undefined' && typeof this.sitemap.sitemap.reduce((arr, elem) => arr.concat(elem.themen), []).reduce((arr, elem) => arr.concat(elem.lernzettel), []).find(x => x.link === this.Slug) == 'undefined') {
        this.ungelistet.ungelistet.push({title: this.unt, link: this.Slug});
        var titel = this.unt;
        extra.doc('ungelistet').set({ ungelistet: this.ungelistet.ungelistet });
        ed.doc(this.Slug).set({content: ""})
        blog.doc(this.Slug).set({slug: this.Slug, title: this.unt, autoren: [fb.auth().currentUser.email] }).then(() => this.$router.push({path: this.Slug}))
        this.unt = ""
      } else {
        this.snackbar = true;
        this.unt = ""
      }
    },
    editUngelistet: function(){
      //
    },
    deleteUngelistet: function(){
      //
    },
    toSlug: function(str){
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();
      // remove accents, swap ñ for n, etc
      var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
      var to   = "aaaaaeeeeeiiiiooooouuuunc------";
      for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }
      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes
      return str;
    },
    end: function(){
      extra.doc('sitemap').set({ sitemap: this.sitemap.sitemap });
    },
    getUserMail: function() {
        if(fb.auth().currentUser == null){
          return null
        }
        return fb.auth().currentUser.email
      }
    },
    mounted(){
      this.$Progress.finish()
    },
    metaInfo: {
      meta: [
          {
            name: 'description',
            content: 'cms'
          }
        ]
    }
  }
</script>